
import $ from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { isUniversity } from "@/functions/userinterface.function";
import { SchoolModel } from "@/models/academy.model";
import Active from "./candidate/Active.vue";
import Inactive from "./candidate/Inactive.vue";
import Import from "./candidate/Import.vue";
import Verify from "./candidate/VerifyRequest.vue";
import toast from "@/functions/toast.function";

@Component({
  components: {
    Active,
    Inactive,
    Import,
    Verify
  }
})
export default class Candidate extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectCandidateVerify", { namespace: "candidate" })
  private actionSelectCandidateVerify: any;
  @Action("actionSelectCandidateActive", { namespace: "candidate" })
  private actionSelectCandidateActive: any;
  @Action("actionSelectCandidateInactive", { namespace: "candidate" })
  private actionSelectCandidateInactive: any;
  @Action("actionResetCandidate", { namespace: "candidate" })
  private actionResetCandidate: any;
  @Action("actionSelectCandidateExport", { namespace: "candidate" })
  private actionSelectCandidateExport: any;
  @Action("actionSelectMajorUnpaged", {namespace: 'requirement'})
  private actionSelectMajorUnpaged: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: SchoolModel;
  @State("pagination_candidate_active", { namespace: "candidate" })
  private pagination_candidate_active: any;
  @State("pagination_candidate_inactive", { namespace: "candidate" })
  private pagination_candidate_inactive: any;
  @State("pagination_verify", { namespace: "candidate" })
  private pagination_verify: any;
  @State("candidate", { namespace: "candidate" })
  private candidate: any;
  @State('array_major', { namespace: 'requirement' })
  private array_major: any;
  @State('locale')
  private locale: any;

  /* INITIALIZATION */

  private tabActive: boolean = true;
  private tabInactive: boolean = false;
  private tabImport: boolean = false;
  private tabVerify: boolean = false;
  private showSearch: boolean = false;
  private search: string = "";
  private tabs: any = null;

  constructor() {
    super();
  }

  private get wordingInviteStudent() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("invite_student_2");
    }

    return this.$i18n.t("invite_student");
  }

  private get wordingStudentData() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("student_data_2");
    }

    return this.$i18n.t("student_data");
  }

  private get wordingStudentID() {
    if (isUniversity(this.school.school_type)) {
      return this.$i18n.t("student_id_nisn_2");
    }

    return this.$i18n.t("student_id_nisn");
  }

  /* LIFECYCLE */

  private created() {
    this.getTab();
    this.actionResetCandidate();
    this.actionSelectCandidateVerify();
    this.actionSelectCandidateActive();
    // this.actionSelectCandidateInactive();
    if (this.$router.currentRoute.name === "candidateDetailEdit") {
      this.activateTab("tabInactive");
    }
    this.actionSelectMajorUnpaged()
  }

  /* METHODS */

  private activateTab(label: string) {
    // Disable all
    for (const key in this.$data) {
      if (key) {
        this.$data[key] = false;
      }
    }

    // Enable selected
    this.$data[label] = true;
  }

  private onReset() {
    this.actionResetCandidate();
    if (this.tabs == 0) {
      this.actionSelectCandidateActive();
    } else {
      this.actionSelectCandidateVerify();
    }
    (this.$refs.searchCandidate as any).hide();
  }

  private clickSearch() {
    if (this.candidate.start_year && this.candidate.start_year < 0) {
      toast.warning(this.$t('warning_start_year_minus'))
      return
    } else if (this.candidate.end_year && this.candidate.end_year < 0) {
      toast.warning(this.$t('warning_graduate_year_minus'))
      return
    } else {
      if (this.tabs == 0) {
        this.actionSelectCandidateActive();
      } else {
        this.actionSelectCandidateVerify();
      }
      (this.$refs.searchCandidate as any).hide();
    }
  }

  private clickTab(val: any) {
    this.setTab();
    this.actionResetCandidate();
    if (this.tabs == 0) {
      this.actionSelectCandidateVerify();
    } else {
      this.actionSelectCandidateActive();
    }
  }

  private clickShowSearch(isShow: boolean) {
    const $element = $('input[type="text"]#search');
    if (isShow) {
      if ($(window).width() <= 735) {
        $("#titleSection span").hide();
        $("#titleSection .ContainerSearch").css("margin-left", 0);
      }
      this.showSearch = isShow;
      $element.css("max-width", 0);
      setTimeout(() => {
        $element.css("max-width", $element.parent().width() * 10);
      }, 10);
    } else {
      if ($(window).width() <= 735) {
        $("#titleSection span").show();
        $("#titleSection .ContainerSearch").css("margin-left", 10);
      }
      this.search = "";
      $element.css("max-width", 0);
      setTimeout(() => {
        this.showSearch = isShow;
      }, 300);
    }
  }

  private getTab() {
    const tabCandidate = localStorage.getItem('TabCandidate');
    if (tabCandidate) {
      this.tabs = parseInt(tabCandidate);
    } else {
      this.tabs = 0;
    }
  }

  private setTab() {
    if (this.tabs === 0) {
      localStorage.setItem('TabCandidate', "1");
    } else {
      localStorage.setItem('TabCandidate', "0");
    }
  }

  private actionInviteCandidate() {
    localStorage.setItem('TabEmailInvitation', "0");
    this.$router.push({ name: 'emailinvitation' })
  }

  private getLabelTranslation(label: string): string {
    if (this.locale === "id") {
      return "translation";
    }
    return 'major';
  }
}
